<nz-steps [nzCurrent]="atual">
    <nz-step nzTitle="Selecione o Arquivo"></nz-step>
    <nz-step nzTitle="Mapeie as Colunas"></nz-step>
    <nz-step nzTitle="Pronto!"></nz-step>
</nz-steps>

<div class="steps-content" style="margin-top: 30px; margin-bottom: 30px;">
    <!--Importação do Arquivo -->
    <div *ngIf="atual === 0">
        <!--<button nz-tooltip nzTooltipTitle="Ao clicar nesse botão você irá baixar uma planilha de exemplo para realizar a importação através dessa tela." nz-button nzType="default" nzSize="small" [nzLoading]="loadingDownloadPlanilha" (click)="downloadPlaninhaExemplo()"
            style="float:right;">
            <i nz-icon nzType="cloud-download" nzTheme="outline"></i> Modelo de Planilha
        </button>
        <br> <br>-->
        <h1 style="text-align: center;">Vamos lá!</h1>
        <p style="text-align: center;">Primeiro preciso que você selecione o arquivo que deseja importar.</p>

        <nz-upload nzType="drag" (nzChange)="handleChange($event)" [nzMultiple]="false" [nzAction]="url" [nzFileList]="fileList" [nzHeaders]="setMediaUploadHeaders" [nzCustomRequest]="upload">
            <p class="ant-upload-drag-icon">
                <i nz-icon nzType="cloud-upload" nzTheme="outline"></i>
            </p>
            <p class="ant-upload-text">Clique ou arraste o arquivo para esta área para fazer o upload</p>
            <p class="ant-upload-hint">
                Selecione aqui arquivo .xlsx que deseja fazer a importação
            </p>
        </nz-upload>
        <label nz-checkbox [(ngModel)]="criar_atualizar" nzValue="1" style="margin-top: 25px;">Na importação, caso o
            cadastro já exista, desejo que ele seja atualizado.</label>

        <p>
            <label nz-checkbox [(ngModel)]="ignorar_primeira_linha" nzValue="1" style="margin-top: 10px;">Ignorar
                primeira linha da planilha.</label>
        </p>
        <p>
            <label nz-checkbox [(ngModel)]="inativar_prod_inexistente" nzValue="1">Inativar cadastros que não estejam na planilha.</label>
        </p>
    </div>

    <!-- Mapear Colunas -->
    <div *ngIf="atual === 1">
        <h1 style="text-align: center;">Últimas Configurações!</h1>
        <p style="text-align: center;">Agora preciso que você me informe o que cada coluna da sua planilha contém.</p>

        <nz-table #basicTable nzSize="small" nzData="[]" nzShowPagination="false" style="padding-left:200px; padding-right: 200px;">
            <thead>
                <tr>
                    <th colspan="1">Colunas</th>
                    <th>Tipo</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let c of colunas | keyvalue; let i = index;">
                    <td>
                        {{c.key | uppercase}}
                    </td>
                    <td>
                        <nz-select style="min-width: 200px;" nzSize="small" nzPlaceHolder="Selecione o tipo" nzAllowClear [(ngModel)]="colunas[c.key]" (ngModelChange)="alteracaoTipo($event)">
                            <ng-container *ngFor="let o of tipos">
                                <nz-option [nzHide]="!o['habilitado']" [nzValue]="o['key']" [nzLabel]="o['descricao']">
                                </nz-option>
                            </ng-container>
                        </nz-select>
                    </td>
                </tr>

            </tbody>
        </nz-table>
        <div style="padding-left:200px; padding-right: 200px;">
            <button nz-button nzType="dashed" [disabled]="disableButtonAddColunas" (click)="mostrarMaisColuna()" nzBlock><i nz-icon nzType="plus"></i>Adicionar Coluna</button>
        </div>

    </div>

    <!-- Finalizar -->
    <div *ngIf="atual === 2">
        <nz-result nzStatus="success" nzTitle="Tudo Certo!" nzSubTitle="Estamos importando seus medicamentos em segundo plano, ao termino do procedimento você será notificado.">

        </nz-result>
    </div>
</div>

<div class="steps-action">
    <button nz-button nzType="default" [nzLoading]="loading" (click)="pre()" [disabled]="atual === 0 || atual === 2">
        <span>Voltar</span>
    </button>
    <button nz-button nzType="primary" [nzLoading]="loading" [disabled]="buttonProximoDisable" (click)="next()" *ngIf="atual < 2" style="float:right;">
        <span>Próximo</span>
    </button>
    <button nz-button nzType="primary" [nzLoading]="loading" (click)="done()" *ngIf="atual === 2" style="float:right;">
        <span>Ok, Fechar!</span>
    </button>
</div>